import React from "react"
import { FaCode, FaSketch, FaDatabase } from "react-icons/fa"
export default [
  {
    id: 1,
    icon: <FaCode className="service-icon" />,
    title: "Problem Solving",
    text: `I'm fascinated with problem solving. It teaches me how to think, cooperate, and grow as a person. The gratification of solving a problem with one's own mental skills is comparable to any other satisfaction in the world.`,
  },
  {
    id: 2,
    icon: <FaSketch className="service-icon" />,
    title: "Machine Learning",
    text: `From the start, this name piqued my interest. Life as a student has always aspired to work in this sector. Machine learning makes me happy when it comes to forecasting unknown data. It reminds me of seeing into the future.`,
  },
  {
    id: 3,
    icon: <FaDatabase className="service-icon" />,
    title: "Web Development",
    text: `Learning web programming from the ground up in order to construct real-world apps. Working with web fields is something I truly appreciate. It assists me in continually learning new things and being acquainted with new technology.`,
  },
]
